import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { Toaster, toast } from "react-hot-toast";
import { allCountriesList } from "../../Api/CountriesAllList";
import {
  a100,
  a18,
  a35,
  a7,
  a714,
  a715,
  a716,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";

import { useRef } from "react";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import { allStateList } from "../../Api/StateList";
import style from "./AddBranchNew.module.css";
import { Icon } from "@iconify/react";
import Customertable from "Components/support/customervendor/customer";
import { Box } from "@mui/material";

export default function AddBranchNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    BranchCode: "",
    CompanyId: "",
    BranchName: "",
    BranchType: "",
    BranchHead: "",
    BranchAddress: "",
    PhoneNumber: "",
    MobileNumber: "",
    FaxNumber: "",
    Street: "",
    Area: "",
    Country: "India",
    Town: "",
    State: "",
    City: "",
    PostalCode: "",
    GSTIN: "",
    BranchEmailId: "",
    BranchStatus: "",
    FinancialYear: "",
    BranchLoginStatus: "",
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a716, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCategories.find((x) => x.id === id);
    setEditedData(selectedItem);
  };


    const inputRef1 = useRef(null);
      const inputRef2 = useRef(null);
      const inputRef3 = useRef(null);
      const inputRef4 = useRef(null);
      const inputRef5 = useRef(null);
      const inputRef6 = useRef(null);
      const inputRef7 = useRef(null);
      const inputRef8 = useRef(null);
      const inputRef9 = useRef(null);
      const inputRef10 = useRef(null);
      const inputRef11 = useRef(null);
      const inputRef12= useRef(null);
      const inputRef13= useRef(null);
      const inputRef14= useRef(null);
      const inputRef15= useRef(null);
      const inputRef16= useRef(null);
      const inputRef17= useRef(null);
      const inputRef18= useRef(null);
      const inputRef19= useRef(null);
      const inputRef20= useRef(null);
      const inputRef21= useRef(null);
      const inputRef22= useRef(null);
  

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
  ];


 
   

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleSaveClick = () => {
    handleSubmit();
    // Save the edited data to your state or send it to an API
    console.log("Edited Data:", editedData);
    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(a35, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();

      console.log(data, "updated");
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message,{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      } else {
        // setMessageType("success");
        toast.success("Updated successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      fetchAllCategory();
    } catch (error) {
      console.error(error);
      alert(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
  };

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      BranchCode: newCategory.OldEntry
        ? String(newCategory.BranchCode)
        : String(allCategories.length + 1),
      ClientCode: clientCode,
      CompanyId: newCategory.CompanyId,
      BranchName: newCategory.BranchName,
      BranchType: newCategory.BranchType,
      BranchHead: newCategory.BranchHead,
      BranchAddress: newCategory.BranchAddress,
      PhoneNumber: newCategory.PhoneNumber,
      MobileNumber: newCategory.MobileNumber,
      FaxNumber: newCategory.FaxNumber,
      Street: newCategory.Street,
      Area: newCategory.Area,
      Country: newCategory.Country,
      Town: newCategory.Town,
      State: newCategory.State,
      City: newCategory.City,
      PostalCode: newCategory.PostalCode,
      GSTIN: newCategory.GSTIN,
      BranchEmailId: newCategory.BranchEmailId,
      BranchStatus: "Active",
      FinancialYear: newCategory.FinancialYear,
      BranchLoginStatus: "Active",
      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a714 : a715,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        BranchCode: "",
        CompanyId: "",
        BranchName: "",
        BranchType: "",
        BranchHead: "",
        BranchAddress: "",
        PhoneNumber: "",
        MobileNumber: "",
        FaxNumber: "",
        Street: "",
        Area: "",
        Country: "",
        Town: "",
        State: "",
        City: "",
        PostalCode: "",
        GSTIN: "",
        BranchEmailId: "",
        BranchStatus: "",
        FinancialYear: "",
        BranchLoginStatus: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message,{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Category Added Successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "BranchName", label: "Branch Name", type: "read", priority: 1 },

    { key: "BranchType", label: "Branch Type", type: "read", priority: 3 },
    { key: "BranchHead", label: "Branch Head", type: "read", priority: 4 },
    { key: "MobileNumber", label: "Mobile Number", type: "read", priority: 5 },
    { key: "BranchStatus", label: "Branch Status", type: "read", priority: 6 },

    {
      key: "BranchLoginStatus",
      label: "Branch Login Status",
      type: "read",
      priority: 7,
    },
  ];

  const handlenew = () => {
    setActive("AddNew");
  };

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Branch"}
          companyName={"Loyalstring"}
          module={"User Masters"}
          page={"Branch"}
        />
      </div>

      <div style={{ padding: "16px" }}>
        {active == "List" ? (
          <>
             <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                    //  onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>
            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,2fr)",
                      columnGap: "30px",
                      margin: "0px 0px",
                      padding: "var(--Space-0, 0px) 24px",
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                    <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      className={style.adminCategoryHeading}
                      id="adminInvoiceAddedCustomerEdit"
                    >
                      Add New Branch
                    </h2>
                    <Box sx={{ width: "95%", margin: "0 auto" }}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>Branch Code</label>
                        <input
                          style={{
                            cursor: "not-allowed",
                            border: "1px solid #ddd",
                          }}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          name="BranchCode"
                          value={
                            newCategory.OldEntry
                              ? newCategory.BranchCode
                              : allCategories.length + 1
                          }
                          readOnly
                          // onChange={handleNewCategoryChange}
                          type="text"
                        />

                        <label>
                          Company ID <sup>*</sup>
                        </label>
                        <select
                          ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                          name="CompanyId"
                          value={newCategory.CompanyId}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required="required"
                        >
                          <option value={""}>Select an option</option>;
                          {allCompaniesList.map((x) => {
                            return (
                              <>
                                <option value={x.Id}>{x.CompName}</option>;
                              </>
                            );
                          })}
                        </select>
                        {/* <input
                    name="CompanyId"
                    value={newCategory.CompanyId}
                    onChange={handleNewCategoryChange}
                    type="text"
                  /> */}

                        <label>
                          Branch Name <sup>*</sup>
                        </label>
                        <input
                          ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                          name="BranchName"
                          value={newCategory.BranchName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required="required"
                          style={{ border: "1px solid #ddd" }}
                        />

                        <label>
                          Branch Type <sup>*</sup>
                        </label>
                        <select
                          name="BranchType"
                          value={newCategory.BranchType}
                          onChange={handleNewCategoryChange}
                          ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                          type="text"
                          required="required"
                        >
                          <option value={""}>Select an option</option>;
                          <option value={"Showroom"}>Showroom</option>
                          <option value={"Warehouse"}>Warehouse</option>
                          <option value={"Exhibition"}>Exhibition</option>
                        </select>

                        <label>Branch Head</label>
                        <input
                          name="BranchHead"
                          value={newCategory.BranchHead}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        />

                        <label>Branch Address</label>
                        <input
                          name="BranchAddress"
                          value={newCategory.BranchAddress}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        />

                        <label>Phone Number </label>
                        <input
                          name="PhoneNumber"
                          value={newCategory.PhoneNumber}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        />

                        {/* <label>Mobile Number</label>
                        <input
                          name="MobileNumber"
                          value={newCategory.MobileNumber}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        /> */}

                        <label>Mobile Number</label>
                        <input
                          name="MobileNumber"
                          value={newCategory.MobileNumber}
                          onChange={(e) => {
                            // Allow only numeric values and limit to 10 digits
                            const filteredValue = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                            handleNewCategoryChange({ target: { name: "MobileNumber", value: filteredValue } });
                          }}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}

                        />


                        <label>Fax Number</label>
                        <input
                          name="FaxNumber"
                          value={newCategory.FaxNumber}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        />
                        <label>Street</label>
                        <input
                          name="Street"
                          value={newCategory.Street}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        />
                        <label>Area</label>
                        <input
                          name="Area"
                          value={newCategory.Area}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        />

                        

                        <label>Town</label>
                        <input
                          name="Town"
                          value={newCategory.Town}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        />


                       <label>City</label>
                        <input
                          name="City"
                          value={newCategory.City}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef13}
                          onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                        />

                       {/* <label>
                          Country <sup>*</sup>
                        </label>
                        <input
                          name="Country"
                          value={newCategory.Country}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required="required"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef14}
                          onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                        /> */}

<label>
                          Country <sup>*</sup>
                        </label>
                        <select
                          name="Country"
                          value={newCategory.Country}
                          className={style.AddCustomerSelect}
                          style={{ border: "1px solid #ccc" }}
                          onChange={handleNewCategoryChange}
                          required="required"
                          ref={inputRef16}
                          onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                        >
                          {allCountriesList.map((x, y) => (
                            <option key={y} value={x}>
                              {x}
                            </option>
                          ))}
                        </select>

                        <label>
                          State <sup>*</sup>
                        </label>
                        <input
                          name="State"
                          value={newCategory.State}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required={"required"}
                          list={"CurrAddState"}
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef15}
                          onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                        />
                        <datalist id="CurrAddState">
                          {allStateList.map((x, index) => (
                            <option key={index} value={x}>
                              {x}
                            </option>
                          ))}
                        </datalist>

                       

                        <label>Postal Code</label>
                        <input
                          name="PostalCode"
                          value={newCategory.PostalCode}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef16}
                          onKeyDown={(e) => handleKeyPress(e, inputRef17)}
                        />

                        <label>GSTIN</label>
                        <input
                          name="GSTIN"
                          value={newCategory.GSTIN}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef17}
                          onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                        />

                        <label>Branch Email ID</label>
                        <input
                          name="BranchEmailId"
                          value={newCategory.BranchEmailId}
                          onChange={handleNewCategoryChange}
                          type="email"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef18}
                          onKeyDown={(e) => handleKeyPress(e, inputRef19)}
                        />

                        {/* <label>Branch Status</label>
                  <input
                    name="BranchStatus"
                    value={newCategory.BranchStatus}
                    onChange={handleNewCategoryChange}
                    type="text"
                  /> */}

                        {/* <label>Financial Year</label>
                        <input
                          name="FinancialYear"
                          value={newCategory.FinancialYear}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef19}
                          onKeyDown={(e) => handleKeyPress(e, inputRef20)}
                        /> */}

<label>Financial Year</label>
<input
  name="FinancialYear"
  value={newCategory.FinancialYear}
  onChange={(e) => {
    // Allow only numbers and a single hyphen
    const filteredValue = e.target.value.replace(/[^0-9\-]/g, ""); // Remove non-numeric and non-hyphen characters
    const match = filteredValue.match(/^(\d{0,4})(-?)(\d{0,4})$/); // Match the format YYYY-YY or YYYY-YYYY
    if (match) {
      const year1 = match[1]; // First 4 digits (YYYY)
      const separator = match[2]; // Optional hyphen
      const year2 = match[3].slice(0, year1.length === 4 ? 4 : 0); // Restrict year2 to 4 digits only if year1 is complete
      e.target.value = year1 + separator + year2;
    } else {
      e.target.value = "";
    }
    handleNewCategoryChange({ target: { name: "FinancialYear", value: e.target.value } });
  }}
  type="text" // Changed from "number" to "text" to allow hyphen
  style={{ border: "1px solid #ddd" }}
  ref={inputRef19}
  onKeyDown={(e) => handleKeyPress(e, inputRef20)}
/>

                      </div>
                    </Box>

                    {/* <label>Branch Login Status</label>
                  <input
                    name="BranchLoginStatus"
                    value={newCategory.BranchLoginStatus}
                    onChange={handleNewCategoryChange}
                    type="text"
                  /> */}
                  </div>
                  {!loading ? 
                    <div className={style["btn-container"]}>
                    <button className={style.buttons} type="submit">
                      <Icon
                        icon="ic:baseline-check"
                        width="24"
                        height="24"
                      />{" "}
                      Submit
                    </button>
                    <button
                    
                      className={style.buttons}
                      style={{
                        backgroundColor: "#fff",
                        color: "#0077d4",
                        border: "1px solid #0077d4",
                      }}
                      type="button"
                      onClick={handleResetField}
                    >
                      <Icon
                        style={{ color: "#0077d4" }}
                        icon="ix:reset"
                        width="24"
                        height="24"
                      />
                      Reset
                    </button>
                    <button
                      className={style.buttons}
                      type="button"
                      onClick={handleList}
                    >
                      <Icon
                        icon="fluent:list-rtl-16-filled"
                        width="24"
                        height="24"
                      />
                      List
                    </button>
                  </div>
                  : null}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
